// ResizableImageComponent.tsx

import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { Image } from '@tiptap/extension-image';
import React, { useRef, useEffect, useState } from 'react';
import './ResizableImage.css';

const ResizableImageComponent = (props) => {
    const containerRef = useRef(null);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [startWidth, setStartWidth] = useState(0);

    const onMouseDown = (e) => {
        if (e.target.classList.contains('resize-handle')) {
            e.preventDefault();
            e.stopPropagation();
            setIsResizing(true);
            setStartX(e.clientX);
            setStartWidth(containerRef.current.offsetWidth);
        }
    };

    const onMouseMove = (e) => {
        if (!isResizing) return;
        const newWidth = startWidth + (e.clientX - startX);
        props.updateAttributes({ width: newWidth });
    };

    const onMouseUp = () => {
        if (isResizing) {
            setIsResizing(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    });

    return (
        <NodeViewWrapper
            className="resizable-image-wrapper"
            contentEditable={false}
            draggable
            onDragStart={(event) => {
                event.stopPropagation();
            }}
        >
            <div
                ref={containerRef}
                className="resizable-image-container"
                style={{
                    width: props.node.attrs.width || '300px',
                    margin: '0 auto',
                    display: 'block',
                }}
            >
                <img
                    src={props.node.attrs.src}
                    alt=""
                    style={{ display: 'block', width: '100%', maxWidth: '100%' }}
                />
                <div
                    className="resize-handle"
                    onMouseDown={onMouseDown}
                    onClick={(e) => e.stopPropagation()}
                />
            </div>
        </NodeViewWrapper>
    );
};

export const ResizableImage = Image.extend({
    draggable: true,

    addAttributes() {
        return {
            ...this.parent?.(),
            width: {
                default: '300px',
                renderHTML: (attrs) => {
                    return {
                        width: attrs.width,
                        style: 'display: block; margin: 0 auto;',
                    };
                },
            },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(ResizableImageComponent);
    },

    addCommands() {
        return {
            ...this.parent?.(),
            setImage:
                (options) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            ...options,
                            width: options.width || '300px',
                        },
                    });
                },
        };
    },
});
